// Process types that can no longer be started in Digital Forms.
// Existing processes of these types are still viewable and can be finished,
// but new ones (including submitting an existing draft) are blocked.
// The backend enforces the same rule (IProcessFactory.CanCreateNew); this is UX only.
const RETIRED_PROCESS_TYPES = ['vip']

export const isRetiredProcessType = (processType) =>
  RETIRED_PROCESS_TYPES.includes((processType ?? '').toLowerCase())
